// extracted by mini-css-extract-plugin
export default {"sort-indicator":"SortIndicator_sort-indicator__cRS1w","is-disabled":"SortIndicator_is-disabled__ICn-y"};